import { EnvelopeIcon } from '@heroicons/react/24/outline'
import Footer from './Footer';
import Topbar from './Topbar';
import BackgroundSVG from './grayscale-world.svg';
import { Field, Label, Switch } from '@headlessui/react'
import { useState } from 'react'



export default function JoinTeam() {
  const [addToEmailList, setAddToEmailList] = useState(true)
  const [isSubmitting, setIsSubmitting] = useState(false);

  function handleSubmit(event) {
    event.preventDefault()
    const data = new FormData(event.target)
    const email = data.get('email')
    const first_name = data.get('first_name')
    const last_name = data.get('last_name')
    const mobile_number = data.get('mobile_number')
    const linkedin_profile = data.get('linkedin_profile')
    const github_profile = data.get('github_profile')
    const explanation = data.get('explanation')
    // console.log(email, first_name, last_name, mobile_number, linkedin_profile, github_profile, explanation, addToEmailList)
    setIsSubmitting(true); // Disable the button and show the spinner
 
    fetch('https://binaryinventions.com/api/application', {
      method: 'POST',
      headers: {        
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        first_name: first_name, 
        last_name: last_name, 
        mobile_number: mobile_number, 
        email: email,
        add_to_email_list: addToEmailList, 
        linkedin_profile: linkedin_profile, 
        github_profile: github_profile, 
        explanation: explanation}),
    })
      .then((data) => {
        console.log('Success:', data)
        // get the id from the data and store it in the local storage
        localStorage.setItem('application_id', data.application_id)
        
        // redirect to the next page
        window.location.href = 'https://binaryinventions.com/inputcode/application'
      })
      .catch((error) => {
        console.error('Error:', error)
    }).finally(() => {
        setIsSubmitting(false); // Enable the button and hide the spinner
    })
  }

  return (
    <div> 
        <Topbar />
    <div className="relative isolate bg-white">
      <div className="mx-auto grid max-w-7xl grid-cols-1 lg:grid-cols-2">
        <div className="relative px-6 pb-20 pt-24 sm:pt-32 lg:static lg:px-8 lg:py-48">
          <div className="mx-auto max-w-xl lg:mx-0 lg:max-w-lg">
            <div className="absolute inset-y-0 left-0 -z-10 w-full overflow-hidden bg-gray-100 ring-1 ring-gray-900/10 lg:w-1/2">
              {/* svg insert with transparancy  */}
              <div className="absolute inset-0 -x-50 w-full h-full bg-gray-100/50" style={{ backgroundImage: `url(${BackgroundSVG})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }} />              </div>
            <h2 className="text-pretty text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">
              Apply today!
            </h2>
            <p className="mt-6 text-lg/8 text-gray-600">
              We're a company without borders or boundaries. Regardless of where you are we want to hear from you. 
            </p>
            <p className="mt-6 text-lg/8 text-gray-600">
                  We are looking forward to reviewing your application!
            </p>
            <dl className="mt-10 space-y-4 text-base/7 text-gray-600">
              {/* <div className="flex gap-x-4">
                <dt className="flex-none">
                  <span className="sr-only">Telephone</span>
                  <PhoneIcon aria-hidden="true" className="h-7 w-6 text-gray-400" />
                </dt>
                <dd>
                  <a href="tel:+1 (800) 246-2791" className="hover:text-gray-900">
                    +1 (800) 246-2791
                  </a>
                </dd>
              </div> */}
              <div className="flex gap-x-4">
                <dt className="flex-none">
                  <span className="sr-only">Email</span>
                  <EnvelopeIcon aria-hidden="true" className="h-7 w-6 text-gray-400" />
                </dt>
                <dd>
                  <a href="mailto:careers@binaryinventions.com" className="hover:text-gray-900">
                    careers@binaryinventions.com
                  </a>
                </dd>
              </div>
            </dl>
          </div>
        </div>
        <form onSubmit={handleSubmit} method="POST" className="px-6 pb-24 pt-20 sm:pb-32 lg:px-8 lg:py-48">
          <div className="mx-auto max-w-xl lg:mr-0 lg:max-w-lg">
            <div className="grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2">
              <div>
                <label htmlFor="first_name" className="block text-sm/6 font-semibold text-gray-900">
                  First name
                </label>
                <div className="mt-2.5">
                  <input
                    id="first_name"
                    name="first_name"
                    type="text"
                    autoComplete="given-name"
                    className="block w-full rounded-md bg-white px-3.5 py-2 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
                  />
                </div>
              </div>
              <div>
                <label htmlFor="last_name" className="block text-sm/6 font-semibold text-gray-900">
                  Last name
                </label>
                <div className="mt-2.5">
                  <input
                    id="last_name"
                    name="last_name"
                    type="text"
                    autoComplete="family-name"
                    className="block w-full rounded-md bg-white px-3.5 py-2 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
                  />
                </div>
              </div>
              <div className="sm:col-span-2">
                <label htmlFor="email" className="block text-sm/6 font-semibold text-gray-900">
                  Email
                </label>
                <div className="mt-2.5">
                  <input
                    id="email"
                    name="email"
                    type="email"
                    autoComplete="email"
                    className="block w-full rounded-md bg-white px-3.5 py-2 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
                  />
                </div>
                <Field className="flex gap-x-4 sm:col-span-2">
                  <div className="flex h-6 items-center">
                    <Switch
                      checked={addToEmailList}
                      onChange={setAddToEmailList}
                      name="add_to_email_list"
                      className="group flex w-8 flex-none cursor-pointer rounded-full bg-gray-200 p-px ring-1 ring-inset ring-gray-900/5 transition-colors duration-200 ease-in-out focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600 data-[checked]:bg-gray-600"
                    >
                      <span className="sr-only">Join our email list.</span>
                      <span
                        aria-hidden="true"
                        className="size-4 transform rounded-full bg-white shadow-sm ring-1 ring-gray-900/5 transition duration-200 ease-in-out group-data-[checked]:translate-x-3.5"
                      />
                    </Switch>
                  </div>
                  <Label className="text-sm/6 text-gray-600">
                    Selected automatically joins our email list!
                  </Label>
                </Field>                
              </div>
              <div className="sm:col-span-2">
                <label htmlFor="mobile_number" className="block text-sm/6 font-semibold text-gray-900">
                  Mobile Number
                </label>
                <div className="mt-2.5">
                  <input
                    id="mobile_number"
                    name="mobile_number"
                    type="tel"
                    autoComplete="tel"
                    className="block w-full rounded-md bg-white px-3.5 py-2 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
                  />
                </div>
              </div>
              <div className="sm:col-span-2">
                <label htmlFor="linkedin_profile" className="block text-sm/6 font-semibold text-gray-900">
                  LinkedIn Profile
                </label>
                <div className="mt-2.5">
                  <input
                    id="linkedin_profile"
                    name="linkedin_profile"
                    type="linkedin"
                    autoComplete="linkedin"
                    className="block w-full rounded-md bg-white px-3.5 py-2 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
                  />
                </div>
              </div>
              <div className="sm:col-span-2">
                <label htmlFor="github_profile" className="block text-sm/6 font-semibold text-gray-900">
                  Github Profile
                </label>
                <div className="mt-2.5">
                  <input
                    id="github_profile"
                    name="github_profile"
                    type="github"
                    autoComplete="github"
                    className="block w-full rounded-md bg-white px-3.5 py-2 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
                  />
                </div>
              </div>

              <div className="sm:col-span-2">
                <label htmlFor="explanation" className="block text-sm/6 font-semibold text-gray-900">
                  Explain briefly why you want to join our team
                </label>
                <div className="mt-2.5">
                  <textarea
                    id="explanation"
                    name="explanation"
                    rows={4}
                    className="block w-full rounded-md bg-white px-3.5 py-2 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
                    defaultValue={''}
                  />
                </div>
              </div>
            </div>
            <div className="mt-8 flex justify-end">
            <button
              type="submit"
              disabled={isSubmitting}
              className={`rounded-md px-3.5 py-2.5 text-center text-sm font-semibold text-white shadow-sm ${
                isSubmitting
                  ? 'bg-gray-400 cursor-not-allowed'
                  : 'bg-gray-600 hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600'
              }`}
            >
              <div className="flex items-center gap-2">
                {isSubmitting && (
                  <svg
                    className="animate-spin h-5 w-5 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                    ></path>
                  </svg>
                )}
                Continue
              </div>
            </button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <Footer />
    </div>
  )
}